import { useConfiguration } from '~/context/common/StaticContext';
import type InventoryConditionalTile from '~/contracts/srp/InventoryConditionalTile';
import { getNccHref } from '~/utilities/srp/ncc/getNccVariant';
import ConditionalTile from './ConditionalTile';

type OwnProps = {
  metaData: InventoryConditionalTile['metaData'];
  position: number;
};

export default function NccTile({ metaData, position }: OwnProps) {
  const { enableNccConditionalPromo } = useConfiguration();

  if (!enableNccConditionalPromo) return null;

  const href = getNccHref(metaData);

  return (
    <ConditionalTile
      anchorProps={{
        'data-analytics-attributes': JSON.stringify({
          action: 'clicked',
          position,
          tile: 'NccTile'
        }),
        'data-analytics-id': 'Conditional Tile',
        href,
        id: 'NccTile'
      }}
      ctaCopy="Shop All New Inventory"
      description="Placeholder — final copy lands in variant stories."
      position={position}
      tileName="NccTile"
      title="New Cars at Carvana"
    />
  );
}
